import { ComponentTypes } from "../../../ComponentFactory/types";

export const TransConfig = {
    rows: [
        {
            name: "Combo PON",
            type: ComponentTypes.STAT,
            isTitle: true,
            id: "combo_pon_title"
        },
        {
            name: "XGS-PON Min TX",
            type: ComponentTypes.INPUT,
            id: "xgs_pon_tx_comb_trans",
            valueID: "gain_loss",
            measure: 'dB'
        },
        {
            name: "XGS-PON RX Sensitivity",
            type: ComponentTypes.INPUT,
            id: "xgs_pon_rx_comb_trans_sens",
            valueID: "gain_loss",
            measure: 'dB'
        },
        {
            name: "GPON Min TX",
            type: ComponentTypes.INPUT,
            id: "gpon_tx_comb_trans",
            valueID: "gain_loss",
            measure: 'dB'
        },
        {
            name: "GPON RX Sensitivity",
            type: ComponentTypes.INPUT,
            id: "gpon_rx_comb_trans_sens",
            valueID: "gain_loss",
            measure: 'dB'
        },
        {
            name: "XGS-PON",
            type: ComponentTypes.STAT,
            isTitle: true,
            id: "xgs_pon_title"
        },
        {
            name: "XGS-PON Min TX",
            type: ComponentTypes.INPUT,
            id: "xgs_pon_tx_xgs_trans",
            valueID: "gain_loss",
            measure: 'dB'
        },
        {
            name: "XGS-PON RX Sensitivity",
            type: ComponentTypes.INPUT,
            id: "xgs_pon_rx_xgs_trans_sens",
            valueID: "gain_loss",
            measure: 'dB'
        },
        {
            name: "GPON",
            type: ComponentTypes.STAT,
            isTitle: true,
            id: "gpon_title"
        },
        {
            name: "GPON Min TX",
            type: ComponentTypes.INPUT,
            id: "gpon_tx_gpon_trans",
            valueID: "gain_loss",
            measure: 'dB'
        },
        {
            name: "GPON RX Sensitivity",
            type: ComponentTypes.INPUT,
            id: "gpon_rx_gpon_sens",
            valueID: "gain_loss",
            measure: 'dB'
        },
    ]
}